// ─────────────────────────────────────────────────────────────────────────────
// ProfileTab.js — identity header, contact rows, and the 2×2 DETAILS grid.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../UserDetailModal.module.css";
import {
  MailIcon, PhoneIcon, PinIcon, ShieldIcon, ClockIcon, GlobeIcon,
} from "../icons";

export default function ProfileTab({ detail }) {
  const {
    name, email, initials, statusLabel, statusColor, statusBg, statusBorder, profile,
  } = detail;

  const contactRows = [
    [<MailIcon />, email],
    [<PhoneIcon />, profile.phone],
    [<PinIcon />, profile.location],
    [<ShieldIcon />, profile.role],
    [<ClockIcon />, `Last active: ${profile.lastActive}`],
    [<GlobeIcon />, `Session: ${profile.sessionRegion}`],
  ];

  return (
    <div className={styles.tab}>
      <div className={styles.identity}>
        <div className={styles.identityAvatar}>{initials}</div>
        <div className={styles.identityMeta}>
          <span className={styles.identityName}>{name}</span>
          <span
            className={styles.statusPill}
            style={{ color: statusColor, background: statusBg, borderColor: statusBorder }}
          >
            <span className={styles.statusDot} style={{ background: statusColor }} />
            {statusLabel}
          </span>
        </div>
      </div>

      <div className={styles.contactList}>
        {contactRows.map(([icon, text], i) => (
          <div key={i} className={styles.contactRow}>
            <span className={styles.contactIcon}>{icon}</span>
            <span className={styles.contactText}>{text}</span>
          </div>
        ))}
      </div>

      <div className={styles.sectionLabel}>Details</div>
      <div className={styles.detailGrid}>
        {profile.details.map(({ label, value, accent }) => (
          <div key={label} className={styles.detailCard}>
            <span className={styles.detailKey}>{label}</span>
            <span
              className={styles.detailVal}
              style={accent ? { color: "var(--accent)" } : undefined}
            >
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
